<template>

    <Dialog :visible.sync="showDialog" :closable="false" :modal="true" :containerStyle="{ width: '60%' }" @hide="hideDialog">
          <Panel class="p-0 ">
            <template #header>
              <h5> Respostas Candidatos </h5>
            </template>
            <transition-group name="p-messages" tag="div" class="col-12 md:col-12">
                <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">{{msg.content}}</Message>
            </transition-group>

            <div class="surface-section m-0 p-0">
              <ul class="list-none p-0 m-4">
                <li class="flex align-items-stretch   flex-wrap surface-border py-2 px-2">
                  <div class="text-500 w-12 md:w-2 font-bold font-medium text-right mr-4">
                    Total de Registros:
                  </div>
                  <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    {{ resumoResposta.total == 0 ? 'NÃO INFORMADO' :  resumoResposta.total }}
                  </div>
                </li>
                <li class="flex align-items-center py-2 px-2  surface-border flex-wrap">
                  <div class="text-500 w-12 md:w-2  font-bold font-medium text-right mr-4">
                    Data Inclusão:
                  </div>
                  <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    {{ resumoResposta.dataInclusao }}
                  </div>
                </li>
                <li class="flex align-items-center py-2 px-2  surface-border flex-wrap">
                  <div class="text-500 w-12 md:w-2  font-bold font-medium text-right mr-4">
                    Arquivo:
                  </div>
                  <div class="text-900 w-full md:w-8 md:flex-order-0 flex-order-1">
                    <input id="arquivo_respostas" type="file" @change="onFileSelected" required="true" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"/>
                  </div>
                </li>
              </ul>
            </div>

          </Panel>
          <template #footer>
            <Button label="Enviar" icon="pi pi-file-o" class=" p-button" @click="enviarRespostas" autofocus v-show="tipoProva == 'OBJETIVA'"/>
            <Button label="Enviar D" icon="pi pi-file-o" class=" p-button" @click="enviarRespostasDiscursivas" autofocus v-show="tipoProva == 'DISCURSIVA'"/>
            <Button label="Fechar" icon="pi pi-times p-button-secondary" class=" p-button-secondary" @click="hideDialog" autofocus/>
          </template>
    </Dialog>

    </template>

    <script>

import InscricaoService from '../../service/InscricaoService';
import ProvaService from '../../service/ProvaService';
import { tratamentoDeErros } from "@/tratamentoDeErros";

    export default {
        mixins: [tratamentoDeErros],
        props: {
            respostaDialog: null,
            processoSeletivo: null,
            tipoProva:{
              default:'OBJETIVA',
            },
        },
        data() {
            return {
              showDialog: false,
              // estrutura objetos
              salasIndividuais: 0,
              resumoResposta: [],
              arquivos: [],
              arquivoSelecionado: null,
              gabaritoSelecionado: null,
              messages: [],
              tiposProva: ['OBJETIVA', 'DISCURSIVA']
            };
        },
        created() {
            this.inscricaoService = new InscricaoService();
            this.provaService = new ProvaService();
        },
        mounted() {

        },
        watch :{
          respostaDialog: function(val) {
            this.messages = [];
            this.showDialog = val;
            console.log(this.tipoProva);
            if (this.tipoProva == 'OBJETIVA') {
              this.getResumoResposta();
            } else if (this.tipoProva == 'DISCURSIVA') {
              this.getResumoRespostaDiscursivas();
            }
          },
        },
        methods: {
          hideDialog() {
            this.$emit('update:respostaDialog', false);
            this.showDialog = false;
          },
          getResumoResposta() {
            this.provaService.getResumoResposta(this.processoSeletivo.id)
                     .then((resumo) => {
                        // console.log(resumo);
                        this.resumoResposta = resumo;
                     });
          },
          getResumoRespostaDiscursivas() {
            this.provaService.getResumoRespostaDiscursivas(this.processoSeletivo.id)
                     .then((resumo) => {
                        // console.log(resumo);
                        this.resumoResposta = resumo;
                     });
          },
          onFileSelected(event){
            console.log(event);
            this.arquivos[event.target.id] = event.target.files[0];
          },
          enviarRespostas() {
            this.$store.state.dlgLoading = true;
            let arquivo = this.arquivos['arquivo_respostas'];
            this.provaService.importarRespostas(this.processoSeletivo.id, arquivo)
                    .then(() => {
                        this.getResumoResposta();
                        this.$store.state.dlgLoading = false;
                        this.$toast.add({
                            severity: "success", summary: "Sucesso", detail: `Respostas importadas com sucesso.`, life: 5000,
                        });
                    })
                    .catch((erro) => {
                        this.messages = this.getMessagesError(erro);
                        this.$store.state.dlgLoading = false;
                    });
          },
          enviarRespostasDiscursivas() {
            this.$store.state.dlgLoading = true;
            let arquivo = this.arquivos['arquivo_respostas'];
            this.provaService.importarRespostasDiscursivas(this.processoSeletivo.id, arquivo)
                    .then(() => {
                        this.getResumoResposta();
                        this.$store.state.dlgLoading = false;
                        this.$toast.add({
                            severity: "success", summary: "Sucesso", detail: `Respostas importadas com sucesso.`, life: 5000,
                        });
                    })
                    .catch((erro) => {
                        this.messages = this.getMessagesError(erro);
                        this.$store.state.dlgLoading = false;
                    });
          }
        }
    }

    </script>

    <style></style>